import { Building2, File, User, Users2 } from "lucide-react";
import { MailQuestion } from 'lucide-react';

export function getMenuList(pathname, user) {
  if (user?.admintype === "Admin" || user?.admintype === "OrganizationAdmin" || user?.admintype === "IndividualAdmin") {
    return [
      {
        groupLabel: "",
        menus: [
          {
            href: "/user",
            label: "User",
            active: pathname.includes("/user"),
            icon: User,
            submenus: [],
          },
        ],
      },
      {
        groupLabel: "",
        menus: [
          {
            href: "/documents",
            label: "Documents",
            active: pathname.includes("/documents"),
            icon: File,
            submenus: [],
          },
        ],
      },
    ];
  } else if (user?.admintype === "SuperAdmin") {
    return [
      {
        groupLabel: "",
        menus: [
          {
            href: "/admin",
            label: "Admin",
            active: pathname.includes("/admin"),
            icon: Users2,
            submenus: [],
          },
        ],
      },
      {
        groupLabel: "",
        menus: [
          {
            href: "/inquiry",
            label: "inquiry",
            active: pathname.includes("/inquiry"),
            icon: MailQuestion,
            submenus: [],
          },
        ],
      },
    ];
  }

  return [];
}
